import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router';
import routes from './router';
import store from './store'
import vuetify from './plugins/vuetify'


Vue.use(VueRouter);
const originalPush = VueRouter.prototype.push;
const originalReplace = VueRouter.prototype.replace;

VueRouter.prototype.push = function push(location, onResolve, onReject) {
    if (onResolve || onReject) {
        return originalPush.call(this, location, onResolve, onReject);
    }

    return originalPush.call(this, location).catch(error => {
        if (error.name !== 'NavigationDuplicated') {
            throw error;
        }
    });
};

VueRouter.prototype.replace = function replace(location, onResolve, onReject) {
    if (onResolve || onReject) {
        return originalReplace.call(this, location, onResolve, onReject);
    }

    return originalReplace.call(this, location).catch(error => {
        if (error.name !== 'NavigationDuplicated') {
            throw error;
        }
    });
};
const router = new VueRouter({routes});
Vue.config.devtools = true;
Vue.config.productionTip = false;

router.beforeEach((toRoute, fromRoute, next) => {
    window.document.title = toRoute.meta && toRoute.meta.title ? toRoute.meta.title : 'Ad Alliance Vendor Tool';
    next();
})

let vm = new Vue({
    router,
    store,
    vuetify,
    render: h => h(App)
}).$mount('#app');

export default vm;